import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const fitmentApi = createApi({
  reducerPath: "fitmentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/fitments`,
  }),
  endpoints: (builder) => ({
    checkFitment: builder.mutation<
      { fits: boolean },
      {
        partId: string;
        vehicle: {
          make: string;
          model: string;
          year: number;
          engine: string;
        };
      }
    >({
      query: (body) => ({
        url: "/check",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useCheckFitmentMutation } = fitmentApi;
